import { render, staticRenderFns } from "./NhlNews.vue?vue&type=template&id=4251d98a&scoped=true"
import script from "./NhlNews.vue?vue&type=script&lang=js"
export * from "./NhlNews.vue?vue&type=script&lang=js"
import style0 from "./NhlNews.vue?vue&type=style&index=0&id=4251d98a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4251d98a",
  null
  
)

export default component.exports